// Folds the chosen size and height into the customer form's tags so they land on the customer record.
class WaitlistForm extends HTMLElement {
  #controller;

  connectedCallback() {
    const form = this.querySelector('form');
    if (!form) return;
    this.#controller = new AbortController();
    form.addEventListener('submit', () => this.#writeTags(form), { signal: this.#controller.signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  #writeTags(form) {
    const tagsInput = form.querySelector('[data-waitlist-tags]');
    if (!tagsInput) return;
    const tags = [tagsInput.dataset.baseTags];
    const size = form.querySelector('[data-waitlist-size]')?.value;
    const height = form.querySelector('[data-waitlist-height]')?.value;
    if (size) tags.push(`taille-${size}`);
    if (height) tags.push(`hauteur-${Math.round(Number(height))}cm`);
    tagsInput.value = tags.join(', ');
  }
}

if (!customElements.get('s-waitlist-form')) customElements.define('s-waitlist-form', WaitlistForm);
